"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _two = _interopRequireDefault(require("@/components/upload/two"));
var _Tinymce = _interopRequireDefault(require("@/components/Tinymce"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ShopCreate',
  components: {
    upload: _two.default,
    Tinymce: _Tinymce.default
  },
  data: function data() {
    return {
      clickSubmit: false,
      form: {
        status: 1,
        product_title: '私密购买，非正品包退'
      },
      rules: {
        product_name: [{
          required: true,
          message: '请填写商品标题',
          trigger: 'blur'
        }],
        product_title: [{
          required: true,
          message: '请填写商品副标题',
          trigger: 'blur'
        }],
        cost_price: [{
          required: true,
          message: '请填写商品成本价',
          trigger: 'blur'
        }],
        market_price: [{
          required: true,
          message: '请填写商品零售价',
          trigger: 'blur'
        }],
        stock_count: [{
          required: true,
          message: '请填写商品库存',
          trigger: 'blur'
        }]
      },
      id: this.$route.query.id || ''
    };
  },
  computed: {
    siteInfo: function siteInfo() {
      var siteInfo = this.$store.getters.siteInfo;
      return siteInfo;
    }
  },
  mounted: function mounted() {
    if (this.id > 0) this.getInfo();
  },
  methods: {
    /**
     * 获取详情
     */
    getInfo: function getInfo() {
      var _this = this;
      this.$get('agentapi/product/sample_detail', {
        id: this.id
      }).then(function (res) {
        _this.form = res;
      });
    },
    /**
     * 提交资料
     * @param {String} formName
     */
    onSubmit: function onSubmit(formName) {
      var _this2 = this;
      var url = 'agentapi/product/sample_save';
      this.clickSubmit = true;
      this.$refs[formName].validate(function (valid, object) {
        if (valid) {
          var params = JSON.parse(JSON.stringify(_this2.form));
          _this2.$post(url, params).then(function (res) {
            _this2.$message({
              message: '提交成功',
              type: 'success'
            });
            _this2.$router.push({
              path: '/condom/goods'
            });
          }).catch(function (err) {
            setTimeout(function () {
              _this2.clickSubmit = false;
            }, 1000);
          });
        } else {
          _this2.formErrow(object);
          _this2.clickSubmit = false;
        }
      });
    }
  }
};